import Option from './option.element.js';

export default Option;

Option.define('wje-option', Option);
